import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { _serverUrl2 } from '../../../config'
import { failed, success } from '../../../Utils/Alerts'
import { loadingSc } from '../../Layout/AlertDiv'
import Message from '../MessageForm/Message'

export default function ConfigDashboard() {

    const [configs, setConfigs] = useState([])

    const getInfosFromNode = async () => {
        loadingSc(true)
        await axios.get(_serverUrl2 + '/main/getConfigs')
            .then((res) => {
                if (res.data.status) {
                    setConfigs(res.data.rows)
                } else {
                    failed('Veriler getirilirken hata oluştu.')
                }
            })
            .catch((err) => {
                failed('Veriler getirilirken hata oluştu.')
            })
            .finally(() => {
                loadingSc(false)
            })
    }

    const onChangeVal = async (id) => {
        loadingSc(true)
        let selectedItem = configs.find(d => d.id == id)
        selectedItem.value = !selectedItem.value
        await axios.post(_serverUrl2 + '/main/updateConfig', selectedItem)
            .then((res) => {
                if (res.data.status) {
                    success('İşlem Başarılı')
                    getInfosFromNode()
                } else {
                    failed('Hata Oluştu')
                }
            })
            .catch((err) => {
                failed('Hata Oluştu')
            })
            .finally(() => {
                loadingSc(false)
            })
    }

    useEffect(() => {
        getInfosFromNode()

        return () => {

        }
    }, [])


    return (
        <div className='row'>
            <div className='col-sm-12'>
                <div className='textBox'>
                    <div className='content'>
                        Uygulama Yönetimi
                    </div>
                </div>
            </div>

            <div className='col-sm-12' style={{ padding: '20px' }} >
                <table className='table table-sm table-bordered'>
                    <tbody>
                        <tr>
                            <th>Adı</th>
                            <th>Özellik</th>
                            <th>Aktiflik</th>
                            <th></th>
                        </tr>
                        {configs.map((d, i) => {
                            return <tr key={i} style={{ fontSize: '13px' }} >
                                <td>{d.label}</td>
                                <td style={{ fontSize: '12px' }} >{d.desc}</td>
                                <td>{d.value ? 'Aktif' : 'Pasif'}</td>
                                <td>{d.value ? <button onClick={() => onChangeVal(d.id)} className='redBtn'>Kapat</button> : <button onClick={() => onChangeVal(d.id)} className='greenBtn'>Aktif Et</button>}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>

            <div style={{ display: 'none' }}>
                <div className='col-12' style={{ padding: '20px' }} >
                    <b>Admin Versiyon Güncelleme</b>
                </div>
                <div className='col-sm-6' >
                    <label>APK Dosyası</label>
                    <input type='file' className='form-control form-control-sm' />
                </div>
                <div className='col-sm-2' >
                    <label>Versiyon</label>
                    <input type='number' className='form-control form-control-sm' />
                </div>
                <div className='col-sm-4' >
                    <label>&nbsp;</label>
                    <button className='greenBtn'>Yeni Versiyon Gönder</button>
                </div>

            </div>
            <div className='col-sm-12' >
                        <Message />
                    </div>
        </div>
    )
}
